
import React from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { BudgetBucket } from "../../types/budget.types";

interface DeleteBucketDialogProps {
  isOpen: boolean;
  onClose: () => void;
  selectedBucket: BudgetBucket | null;
  onDelete: () => Promise<void>;
}

export const DeleteBucketDialog: React.FC<DeleteBucketDialogProps> = ({
  isOpen,
  onClose,
  selectedBucket,
  onDelete
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Delete Budget Bucket</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete this budget bucket? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        
        <div className="py-4">
          <p className="mb-2">You are about to delete:</p>
          <div className="p-3 bg-secondary/10 rounded-md">
            <p className="font-medium">{selectedBucket?.name}</p>
            <p className="text-sm text-black">
              Budget: ${selectedBucket?.budget.toLocaleString()}
            </p>
          </div>
          
          {selectedBucket?.subcategories.length ? (
            <div className="mt-4 bg-red-500/10 border border-red-500/30 p-3 rounded-md text-sm">
              <p className="text-red-500">
                Cannot delete: This bucket has {selectedBucket.subcategories.length} subcategories.
                Please delete all subcategories first.
              </p>
            </div>
          ) : null}
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button 
            className="bg-red-600 hover:bg-red-700 text-white"
            variant="destructive" 
            onClick={onDelete} 
            disabled={selectedBucket?.subcategories.length ? true : false}
          >
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
